var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVentilator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 65,
    viewBox: "0 0 63 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3416_48444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1764 34.9023C45.1764 34.9023 44.1133 41.9394 37.0264 43.5227C37.0264 43.5227 38.7981 48.9765 38.178 53.3746C37.6465 57.0691 36.3177 66.5691 46.328 63.4904C56.3384 60.4996 64.7542 49.9441 61.3878 42.995C58.0215 36.0459 45.1764 34.9023 45.1764 34.9023Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1644 25.1385C42.1644 25.1385 46.1508 21.0042 50.3144 19.5088C53.8579 18.2773 62.8938 14.9347 55.4525 7.6338C48.1883 0.33285 34.8116 -2.13012 30.2051 4.0273C25.5986 10.1847 30.648 22.0598 30.648 22.0598C30.648 22.0598 37.3807 19.6848 42.1644 25.1385Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0759 34.7267C41.0129 39.2128 36.4949 42.0276 31.977 40.9721C27.459 39.9165 24.6242 35.4304 25.6873 30.9443C26.7503 26.4582 31.2683 23.6433 35.7862 24.6989C40.3042 25.7544 43.139 30.2406 42.0759 34.7267Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.764 29.7125C22.764 29.7125 17.0944 28.7449 13.4623 26.106C10.4503 23.9069 2.65466 18.3652 0.705738 28.481C-1.24318 38.5968 4.16064 50.9116 11.8677 51.2635C19.5748 51.5274 26.6618 40.8838 26.6618 40.8838C26.7504 40.8838 20.9922 36.7496 22.764 29.7125Z",
    fill: "#9C9C9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3416_48444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.7453,
    height: 63.5094,
    fill: "white",
    transform: "translate(0.351562 0.508789)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentilator);
export default __webpack_public_path__ + "static/media/ventilator.cd0cfabe8bacab50bfff4da2005c8d1c.svg";
export { ForwardRef as ReactComponent };